/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ImagesRepoService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Get an Image
     * 
     * @param type 
     * @param imageId 
     * @param ext 
     * @param width 
     * @param thumbnail 
     * @param page backupGenreId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getImage(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', width: number, thumbnail?: boolean, page?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getImage(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', width: number, thumbnail?: boolean, page?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getImage(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', width: number, thumbnail?: boolean, page?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getImage(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', width: number, thumbnail?: boolean, page?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getImage.');
        }

        if (imageId === null || imageId === undefined) {
            throw new Error('Required parameter imageId was null or undefined when calling getImage.');
        }

        if (ext === null || ext === undefined) {
            throw new Error('Required parameter ext was null or undefined when calling getImage.');
        }

        if (width === null || width === undefined) {
            throw new Error('Required parameter width was null or undefined when calling getImage.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (thumbnail !== undefined && thumbnail !== null) {
            queryParameters = queryParameters.set('thumbnail', <any>thumbnail);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'image/jpeg'
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.get<any>(`${this.getBasePath()}/api/v1/images-repo/${encodeURIComponent(String(type))}/w/${encodeURIComponent(String(width))}/${encodeURIComponent(String(imageId))}.${encodeURIComponent(String(ext))}`,
            {
                params: queryParameters,
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get an Image
     * 
     * @param type 
     * @param imageId 
     * @param ext 
     * @param thumbnail 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getImageNoSize(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', thumbnail?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getImageNoSize(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', thumbnail?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getImageNoSize(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', thumbnail?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getImageNoSize(type: 'programs' | 'albums' | 'channels' | 'genres', imageId: number, ext: 'jpg' | 'png' | 'gif', thumbnail?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getImageNoSize.');
        }

        if (imageId === null || imageId === undefined) {
            throw new Error('Required parameter imageId was null or undefined when calling getImageNoSize.');
        }

        if (ext === null || ext === undefined) {
            throw new Error('Required parameter ext was null or undefined when calling getImageNoSize.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (thumbnail !== undefined && thumbnail !== null) {
            queryParameters = queryParameters.set('thumbnail', <any>thumbnail);
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'image/jpeg'
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.get<any>(`${this.getBasePath()}/api/v1/images-repo/${encodeURIComponent(String(type))}/${encodeURIComponent(String(imageId))}.${encodeURIComponent(String(ext))}`,
            {
                params: queryParameters,
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
